/**
 * @type {string}
 * @description - The tabs layout web component.
 */
export const TABS_LAYOUT_WEB_COMPONENT = 'tabs-layout';

/**
 * @type {string}
 * @description - The toggle tab panes event.
 */
export const TOGGLE_TAB_PANES_EVENT = 'toggle-tab-panes';
